
import React from "react";  
import { Link } from "react-router-dom";
import freezerVanInterior from "../../assets/images/FreezerVan/freezer-van-service.webp";
import chillerVanImage from "../../assets/images/Home/chiller-van-for-refrigerated-transport.webp";
import freezerTruckInterior from "../../assets/images/FreezerVan/chiller-truck-service.webp";
import "../../styles/FastChillerVan.css";

const TrucksVansComparison = () => {
  const vehicles = [
    {
      title: "Freezer Van Rental",
      img: freezerVanInterior,
      alt: "Insulated freezer van interior with cooling unit",
      desc: "Our freezer vans provide reliable transport for frozen goods. Ideal for ice cream, seafood, and pharmaceuticals with precise temperature control.",
      readMore: "/services/freezer-vans",
    },
    {
      title: "Chiller Van for Rent",
      img: chillerVanImage,
      alt: "White chiller van for refrigerated transport",
      desc: "Our chiller vans keep fresh produce, dairy, and beverages perfectly chilled with timely delivery across Dubai and UAE.",
      readMore: "/services/chiller-vans",
    },
    {
      title: "Freezer Truck Rental",
      img: freezerTruckInterior,
      alt: "Freezer truck interior with cooling unit",
      desc: "Our freezer trucks handle bulk frozen cargo at –18°C, perfect for supermarkets and long-distance logistics.",
      readMore: "/services/freezer-trucks",
    },
  ];

  return (
    <section className="tv-section">
      <div className="container-fluid container-lg">

        <h2 className="tv-title text-center" data-aos="fade-up" data-aos-delay="300">
          Freezer Van, Chiller Van & Freezer Truck Comparison
        </h2>

        <div className="row tv-grid" >
          {vehicles.map((item, index) => (
            <div className="col-lg-4 col-md-6 col-12" key={index} data-aos="zoom-in" data-aos-delay="300">
              <div className="tv-card">

                <div className="tv-img-wrapper">
                  <img src={item.img} alt={item.alt} />
                </div>

                <div className="tv-content">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>

                 <Link to={item.readMore} className="tv-btn">
  Read More
</Link>

                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TrucksVansComparison;